import { CollegeGoal } from '@common/goals';
import { getGoalBaseConfig } from '@common/react/goals';
import { getRecommendedRiskScoreUsingTargetDate } from '../helpers';
import { GoalConfig } from './types';

export const COLLEGE: GoalConfig<CollegeGoal> = {
    inputSteps: [
        // TODO
    ],
    getGoalStatementContent: () => {
        // TODO
        return null;
    },
    getAssumptionsContent: () => (
        // TODO
        <></>
    ),
    getRecommendedRiskScore: (config) =>
        getRecommendedRiskScoreUsingTargetDate(config),
    getTargetDate: ({ goalData }) => goalData.targetDate,
    ...getGoalBaseConfig('COLLEGE'),
};
